document.addEventListener('DOMContentLoaded', function() {
  const sliderComponent = document.querySelector('slider-component.slider-mobile-gutter');
    let resizeTimeout;

    function handleResize() {
        // Clear the timeout if it exists
        clearTimeout(resizeTimeout);
        
        // Add delay to prevent excessive updates during resize
        resizeTimeout = setTimeout(() => {
            if (window.innerWidth <= 768) {
                sliderComponent.classList.remove('page-width-desktop');
            } else {
                sliderComponent.classList.add('page-width-desktop');
            }
        }, 100); // Adjust the delay (100ms) if needed
    }

    // Initial check on page load
    handleResize();

    // Add resize event listener
    window.addEventListener('resize', handleResize);
});